import React, { Component } from 'react'

export class FilesByApplcation extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("FilesByApplcation");
    this.state = {
      list: []
    };

    this.outerclass = "d-flex flex-wrap";
    this.passwordclass = "";
  }

  getAllDocuments() {
    this.api.apiGetApplicationDocumentsAll({},this.props.urlparams).then((response) => {
      this.setState(()=>({
        list:response.credit||[]
      }));
    });
  }
  componentDidMount() {
    this.getAllDocuments();
  }

  uploadDocument(event, name, documentKey, offsetkey = "", offsetvalue = "") {
    let { props } = this;
    let input = event.target;
    let [file] = input.files;
    let docmeta = { name, group: "credit", documentKey: documentKey, offsetkey, [offsetkey || 'offsetvalue']: offsetvalue };
    let payload = {
      application_id: this.props.urlparams.application_id,
      file,
      doc_meta_name: JSON.stringify(docmeta).encode()
    };
    this.api.execApi("postDocument", payload, {}, {
      multipart:true, 
      message:"Uploading please wait...",
      onexec:() => {
        success("Upload Successfull").promise.then(() => {
          this.getAllDocuments();
        });
      }
    });
  }

  deleteDocument(file) {
    let payload = {attachment_id:file.attachment_id};
    this.api.execApi('deleteDocument',{},payload).then(()=>{
      this.getAllDocuments();
    });
  }

  downloadDocument(args) {
    console.log({args});
    let payload = {attachment_id:args['data-invalue']};
    this.api.execApi('getDocument',{},payload).then((response)=>{
      dowload(response,args['data-filename']);
      this.getAllDocuments();
    });
  }

  getFile(name, offsetkey="",offsetvalue="") {
    return this.state.list.find(o => o.doc_meta_name.name == name && o.doc_meta_name[offsetkey||"offsetvalue"] == offsetvalue);
  }

  getFileAttrs(file) {
    return {
      "data-invalue": file?.attachment_id,
      "data-filename": file?.file_name,
      isuploaded: (!!file),
      labelname: file?.file_name
    }
  }

  render() {
    let { outerclass, passwordclass, state } = this;
    let { list } = state;
    return (
      <div className='p-2'>
        {list.map((file,index) => (
          <div className='row'>
            <div className='col-12 col-md-2'>
              <span>{index+1}</span>
              <AppUploadPassword
                label="File Name"
                name={file.name}
                passwordclass={passwordclass}
                outerclass={outerclass}
                editaccess="true"
                onChange={(e) => this.uploadDocument(e, file, props.documentKey)}
                onDelete={(...args) => this.deleteDocument(file)}
                onDownload={(...args) => this.downloadDocument(file)}
                defaultValue={""}
                {...this.getFileAttrs(file)}
              />
            </div>
            <div className='col-12 col-md-10'>
              <div className='row'>
                  {
                    Object.entries(file.doc_meta_name).map(([key,value])=>(
                      <div className='col'>
                        <AppInput 
                          type="text" 
                          readOnly 
                          label={key}
                          defaultValue={value} 
                          >
                        </AppInput>
                      </div>
                    ))
                  }
              </div>
            </div>
          </div>
        ))}
      </div>
    )
  }
}

export default connect(FilesByApplcation);